import { useEffect } from "react";
import { Stack, Text } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import api from "@/core/api/axios";
import { Button } from "@/design-system";
import { BUILD_APP_VERSION, reloadPage } from "../utils/appVersion";
import { registerAppVersionHeader } from "../utils/registerAppVersionHeader";
import {
  getDeployedVersion,
  useAppVersionStore,
} from "../stores/appVersionStore";
import { useAppVersionCheck } from "../hooks/useAppVersionCheck";
import { useReloadOnNavigation } from "../hooks/useReloadOnNavigation";

export const APP_UPDATE_NOTIFICATION_ID = "app-update-available";

// No import, antes do primeiro render que dispara request: o axios é singleton
// e o registro é idempotente. Fica aqui (e não em `core/api/axios`) para o
// hotfix entrar por cherry-pick sem conflito com o que mudou naquele arquivo.
registerAppVersionHeader(api(), BUILD_APP_VERSION);

/**
 * SA-1416: percebe que saiu versão nova, avisa e recarrega na próxima troca de
 * seção. Montado uma vez no `AppProvider`, dentro do router.
 */
export function AppVersionWatcher() {
  const updateAvailable = useAppVersionStore((state) => state.updateAvailable);
  useAppVersionCheck();
  useReloadOnNavigation();

  useEffect(() => {
    if (!updateAvailable) return;
    // Id fixo: o Mantine descarta um id já presente, então não duplica.
    notifications.show({
      id: APP_UPDATE_NOTIFICATION_ID,
      title: "Tem uma versão nova da plataforma",
      autoClose: false,
      withBorder: true,
      message: (
        <Stack
          gap="xs"
          align="flex-start">
          <Text size="sm">
            Vamos atualizar na próxima troca de página. Se preferir, atualize
            agora.
          </Text>
          <Button
            size="xs"
            variant="primary"
            onClick={() => reloadPage(getDeployedVersion())}>
            Atualizar agora
          </Button>
        </Stack>
      ),
    });
  }, [updateAvailable]);

  return null;
}
